export const SYSTEM_SUBSCRIPTION_TYPE_FIELD = "systemSubscriptionType";
